import { cn } from "../lib/utils";

const STATUS_STYLES = {
  open: "bg-[#0033CC] text-white border-[#0033CC]",
  closed: "bg-[#DC2626] text-white border-[#DC2626]",
  expired: "bg-zinc-200 text-zinc-700 border-zinc-300",
};

export default function StatusBadge({ status, className, ...props }) {
  const s = (status || "").toLowerCase();
  return (
    <span
      data-testid={`status-badge-${s}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] border rounded-none",
        STATUS_STYLES[s] || "bg-zinc-100 text-zinc-700 border-zinc-300",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          s === "open" && "bg-white",
          s === "closed" && "bg-white",
          s === "expired" && "bg-zinc-500"
        )}
      />
      {s || "unknown"}
    </span>
  );
}
